import { useQuery } from '@apollo/client'

import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Box, FloraButton, Flex } from '@grupoboticario/flora-react'

import Filter from '@/components/Filter/Filter'
import EventsTable from '@/components/Table/EventsTable/EventsTable'
import { EVENT_TYPE_FILTER } from '@/constants/eventColumns'
import { useUserContext } from '@/context/user'
import { GET_BENEFIT_EVENTS_LIST } from '@/graphql/queries/benefitEvents'
import { PlusCircle } from '@/icons/PlusCircle'
import { Actions } from '@/utils/dictionaries/actionsDictionary/actions'
import { applyFilters } from '@/utils/events/filterEvents'
import { sortEvents } from '@/utils/events/sortEvents'
import { benefitsEventsFilter } from '@/utils/filterSchemas/benefitsEventsFilter'
import { toElasticSearch } from '@/utils/format/toElasticSearch'

import * as P from '../../pages.styles'
import * as E from './events.styles'

const EventsPage = () => {
  const [filterState, setFilterState] = useState({ status: '', region: '', tag: '', name: '' })
  const [pagination, setPagination] = useState({ from: 0, size: 10 })
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [events, setEvents] = useState({ benefitEvents: { items: [], size: 0, total: 0 } })
  const { hasPermission } = useUserContext()
  const [sort, setSort] = useState({
    column: 'redeemEnd',
    order: 'asc'
  })

  const { data, loading, refetch } = useQuery(GET_BENEFIT_EVENTS_LIST, {
    variables: {
      filter: toElasticSearch(filterState, pagination, {
        match_phrase: {
          types: EVENT_TYPE_FILTER
        }
      })
    }
  })

  useEffect(() => {
    const filters = [
      { key: 'name', value: filterState.name, type: 'partial' },
      { key: 'region', value: filterState.region, type: 'exact' },
      { key: 'tag', value: filterState.tag, type: 'exact' },
      { key: 'status', value: filterState.status, type: 'exact' }
    ]

    let filteredData = applyFilters(data, filters)
    filteredData = sortEvents(filteredData, sort)

    setEvents(filteredData)
  }, [data, filterState, sort])

  useEffect(() => {
    if (searchParams.get('refresh')) refetch()
  }, [searchParams, refetch])

  return (
    <Box css={P.pageWrapperCss}>
      <Flex align="center" css={E.headerRowCss} justify="space-between">
        <FloraButton
          disabled={!hasPermission(Actions.CREATE_EXCLUSIVE_EVENT)}
          onClick={() => navigate('/benefits/event/new')}
          size="small"
          has="iconLeft"
          icon={<PlusCircle />}
        >
          Cadastrar evento
        </FloraButton>
      </Flex>

      <Filter
        content={benefitsEventsFilter}
        css={P.sectionSpacerCss}
        defaultKey="name"
        onChange={setFilterState}
        placeholder="Busque por nome do evento"
        state={filterState}
        type="text"
      />

      <EventsTable
        data={events?.benefitEvents || { items: [] }}
        filter={filterState}
        loading={loading}
        onPaginationChange={setPagination}
        onSortChange={setSort}
        sort={sort}
      />
    </Box>
  )
}

export default EventsPage

export { EventsPage as BenefitEventsPage }
